
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/wixData/components/collectionsList/collectionsListHeader.scss.css.virtualfile';
        module.exports = {"header":"_header_3sfsj_1","headerText":"_headerText_3sfsj_7","title":"_title_3sfsj_11","headerActions":"_headerActions_3sfsj_14"};